import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicItemBaseComponent } from '@ups/xplat/dynamic-render';
import '../../dynamic-options-web.augment';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-dynamic-safetyatrisk',
  templateUrl: './dynamic-safetyatrisk.component.html',
  styleUrls: ['./dynamic-safetyatrisk.component.scss'],
  standalone: false,
})
export class DynamicSafetyAtRiskComponent extends DynamicItemBaseComponent {}
